import { reactive, watch } from 'vue';
import type { KnownExceptionKey } from '@/types';

export type ErrorPopup = {
  open: boolean;
  title?: string;
  message?: string;
  knownErrorKey?: keyof KnownExceptionKey;
  description?: string;
  metadata?: Record<string, unknown>;
};

const DEFAULT_ERROR_POPUP: ErrorPopup = {
  knownErrorKey: undefined,
  metadata: undefined,
  title: '',
  message: '',
  open: false,
};

export const errorPopup = reactive<ErrorPopup>({ ...DEFAULT_ERROR_POPUP });

watch(
  () => errorPopup.open,
  open => {
    if (!open) {
      Object.assign(errorPopup, DEFAULT_ERROR_POPUP);
    }
  },
);

export const awaitClosingOfErrorPopup = (): Promise<void> =>
  new Promise(resolve => {
    watch(
      () => errorPopup.open,
      (isOpen: boolean, wasOpen: boolean) => {
        if (wasOpen && !isOpen) {
          resolve();
        }
      },
    );
  });
